import { IFormConfirmInvivation } from "../../modules/auth/interfaces";
import {
  EditPermissionsCollaborator,
  IFilterCollaborator,
  InviteCollaborator,
} from "../../modules/collaborator/interfaces";
import { api } from "../api";

async function sendInvite({ data, application }: InviteCollaborator) {
  await api.post(`/user/collaborator?application=${application}`, data);
}

async function loadCollaborators({ farmId, page, limit }: IFilterCollaborator) {
  const { data } = await api.get(
    `/user/collaborator?farmId=${farmId}&page=${page}&limit=${limit}`
  );

  return data;
}

async function loadCollaboratorById(id: string) {
  const { data } = await api.get(`/user/${id}`);

  return data;
}

async function resendInvivation(id: string, application: string) {
  await api.get(
    `/user/collaborator/resendInvite/${id}?application=${application}`
  );
}

async function editPermissions({
  application,
  permission,
  id,
}: EditPermissionsCollaborator) {
  await api.put(`/user/permission/${id}`, {
    application,
    permission,
  });
}

async function confirmInvivation({ code, dob }: IFormConfirmInvivation) {
  const { data } = await api.get(
    `/user/validatecode?code=${code}&date_birth=${dob}`
  );

  return data;
}

export {
  sendInvite,
  loadCollaborators,
  loadCollaboratorById,
  resendInvivation,
  editPermissions,
  confirmInvivation,
};
